<template>
    <section class="project-step mgt-3 mgb-3" v-if="project">
        <div class="custom-container">
            <form id="form-edit-project" class="step-form general-form">
                <div class="row project-heading-row">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="return-btn-container">
                            <a href="/developer/projects">
                                <i class="fad fa-long-arrow-alt-left"></i>
                                <span> Inapoi </span>
                            </a>
                        </div>
                        <div class="section-heading">
                            <i class="fad fa-layer-plus"></i>
                            <h1 class="m-color">
                                Modifica proiectul {{project.name}}
                            </h1>
                        </div>
                    </div>
                </div>
                <div class="row project-step-row">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="secondary-heading">
                            <div class="secondary-heading-icon">
                                <i class="fad fa-images"></i>
                            </div>
                            <span> Informatii Generale </span>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-12 col-12">
                        <div class="single-img-upload">
                            <div class="single-img-edit">
                                <input type='file' id="imageUpload" name="logo" accept=".png, .jpg, .jpeg"
                                       @change="onFileChange"/>
                                <label for="imageUpload" v-if="!logoUrl">
                                    <h3> Incarca logo </h3>
                                    <div class="add-image-btn">
                                        <i class="fad fa-edit"></i>
                                    </div>
                                </label>
                            </div>
                            <div class="single-img-preview">
                                <div class="previewer" id="imagePreview"
                                     :style="{'background-image' : 'url('+ logoUrl +')'}">
                                </div>
                            </div>
                            <div class="clear-post-img" v-if="logoUrl" @click="deleteLogo()">
                                <i class="fad fa-trash-alt"></i>
                            </div>
                        </div>
                        <p class="custom-input-error" id="logo_error"></p>
                    </div>
                    <div class="col-xl-8 col-lg-8 col-md-12 col-12">
                        <div class="row">
                            <div class="col-lg-12 col-xl-12 col-md-12 col-12">
                                <div class="input-container">
                                    <div class="input-group mg-b">
                                        <input type="text" id="project_name" name="name" :value="project.name"
                                               placeholder="* Nume proiect">
                                        <div class="input-icon">
                                            <i class="fad fa-signature"></i>
                                        </div>
                                        <label class="custom-label" for="project_name"> * Nume proiect </label>
                                    </div>
                                    <p class="custom-input-error" id="name_error"></p>
                                </div>
                            </div>
                            <!--<div class="col-lg-12 col-xl-12 col-md-12 col-12">
                                <div class="input-group mg-b">
                                    <input type="number" id="project_code" name="project_code" value="" placeholder="Cod proiect">
                                    <div class="input-icon">
                                        <i class="fad fa-barcode"></i>
                                    </div>
                                </div>
                            </div>-->
                            <div class="col-lg-12 col-xl-12 col-md-12 col-12">
                                <div class="input-container">
                                    <div class="input-group mg-b">
                                        <select name="county" id="pas1_county" @change="changeCounty()">
                                            <option selected="selected" disabled="disabled" value=""> * Alege Judet
                                            </option>
                                            <option v-for="(county, index) in counties" :value="county.id" :key="index"
                                                    :selected="county.id === project.county.id">
                                                {{county.name}}
                                            </option>
                                        </select>
                                        <div class="input-icon">
                                            <i class="fad fa-signature"></i>
                                        </div>
                                        <label class="custom-label" for="pas1_county"> * Alege Judet </label>
                                    </div>
                                    <p class="custom-input-error" id="county_error"></p>
                                </div>
                            </div>
                            <div class="col-lg-12 col-xl-12 col-md-12 col-12">
                                <div class="input-container">
                                    <div class="input-group mg-b">
                                        <select name="city" id="pas1_city" v-model="selectedCity" ref="pas1_city" @change="changeCity()">
                                            <option disabled="disabled" selected="selected" value=""> * Alege Oras</option>
                                            <option v-for="(city, index) in cities"
                                                    :value="city.id"
                                                    :key="index"
                                            >
                                                {{city.name}}
                                            </option>
                                        </select>
                                        <div class="input-icon">
                                            <i class="fad fa-signature"></i>
                                        </div>
                                        <label class="custom-label" for="pas1_city"> * Alege Oras </label>
                                    </div>
                                    <p class="custom-input-error" id="city_error"></p>
                                </div>
                            </div>
                            <div class="col-lg-12 col-xl-12 col-md-12 col-12" v-if="zones.length > 0">
                                <div class="input-container">
                                    <div class="input-group mg-b">
                                        <select name="zone" v-model="selectedZone" id="pas1_zone" @change="changeZone()">
                                            <option selected="selected" disabled="disabled"> * Alege Zona</option>
                                            <option v-for="(zone, index) in zones" :value="zone.id" :key="index">
                                                {{zone.name}}
                                            </option>
                                        </select>
                                        <div class="input-icon">
                                            <i class="fad fa-signature"></i>
                                        </div>
                                        <label class="custom-label" for="pas1_zone"> * Alege Zona </label>
                                    </div>
                                    <p class="custom-input-error" id="zone_error"></p>
                                </div>
                            </div>
                            <div class="col-lg-12 col-xl-12 col-md-12 col-12" v-if="subzones.length > 0">
                                <div class="input-container">
                                    <div class="input-group mg-b">
                                        <select name="subzone" v-model="selectedSubzone" id="pas1_subzone">
                                            <option selected="selected" disabled="disabled"> * Alege Subzona
                                            </option>
                                            <option v-for="(subzone, index) in subzones" :value="subzone.id"
                                                    :key="index"> {{subzone.name}}
                                            </option>
                                        </select>
                                        <div class="input-icon">
                                            <i class="fad fa-signature"></i>
                                        </div>
                                        <label class="custom-label" for="pas1_subzone"> * Alege Subzona </label>
                                    </div>
                                    <p class="custom-input-error" id="subzone_error"></p>
                                </div>
                            </div>
                            <div class="col-lg-12 col-xl-12 col-md-12 col-12">
                                <div class="input-container">
                                    <div class="input-group mg-b">
                                        <select name="promotion_level" :value="project.promotion_level" id="pas1_promotion_level">
                                            <option selected="selected" disabled="disabled"> * Alege Nivelul de Promovare
                                            </option>
                                            <option v-for="(promotionLevelName, promotionLevelValue) in promotionLevels"
                                                    :value="promotionLevelValue"
                                                    :key="promotionLevelValue"> {{promotionLevelName}}
                                            </option>
                                        </select>
                                        <div class="input-icon">
                                            <i class="fad fa-signature"></i>
                                        </div>
                                        <label class="custom-label" for="pas1_promotion_level"> * Alege Nivelul de Promovare </label>
                                    </div>
                                    <p class="custom-input-error" id="promotion_level_error"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row project-step-row">
                    <div class="col-lg-12 col-xl-12 col-md-12 col-12">
                        <div class="dynamic-group-wrapper">
                            <div class="secondary-heading">
                                <div class="secondary-heading-icon">
                                    <i class="fad fa-id-card"></i>
                                </div>
                                <span> Persoane de contact </span>
                            </div>
                        </div>
                        <div class="dynamic-group-wrapper">
                            <div class="dynamic-input-group row" v-for="(contactRow, index) in contactRows"
                                 :key="index">
                                <div class="single-dynamic-input-group col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                                    <div class="input-container">
                                        <div class="input-group mg-b">
                                            <input :id="`contact-phone-${index}`" placeholder="Telefon"
                                                   name="contact[phone][]" :value="contactRow.phone" type="text">
                                            <div class="input-icon">
                                                <i class="fad fa-phone-rotary"></i>
                                            </div>
                                            <label class="custom-label" :for="`contact-phone-${index}`">
                                                Telefon </label>
                                        </div>
                                        <p class="custom-input-error" :id="`contact-phone-${index}_error`"></p>
                                    </div>
                                </div>
                                <div class="single-dynamic-input-group col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                                    <div class="input-container">
                                        <div class="input-group mg-b">
                                            <input :id="`contact-name-${index}`" placeholder="Nume"
                                                   name="contact[name][]" :value="contactRow.name" type="text">
                                            <div class="input-icon">
                                                <i class="fad fa-signature"></i>
                                            </div>
                                            <label class="custom-label" :for="`contact-name-${index}`">
                                                Nume </label>
                                        </div>
                                        <p class="custom-input-error" :id="`contact-name-0_error`"></p>
                                    </div>
                                </div>
                                <div class="single-dynamic-input-group col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                                    <div class="input-container">
                                        <div class="input-group mg-b">
                                            <input :id="`contact-email-${index}`" placeholder="Email"
                                                   name="contact[email][]" :value="contactRow.email" type="email">
                                            <div class="input-icon">
                                                <i class="fad fa-at"></i>
                                            </div>
                                            <label class="custom-label" :for="`contact-email-${index}`">
                                                Email </label>
                                        </div>
                                        <p class="custom-input-error" :id="`contact-email-${index}_error`"></p>
                                    </div>
                                </div>
                                <div class="add-field-btn" v-if="index === 0" @click="addContactRow">
                                    <i class="fad fa-plus-circle"></i>
                                </div>
                                <div class="remove-field-btn" v-if="index > 0">
                                    <i class="fad fa-minus-circle" v-on:click="removeContactElement(index)"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row project-step-row">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                        <div class="map-perimeter-wrapper">
                            <div class="secondary-heading">
                                <div class="secondary-heading-icon">
                                    <i class="fad fa-border-style-alt"></i>
                                </div>
                                <span> Perimetru Proiect </span>
                            </div>
                            <div class="single-dynamic-input-group col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                <div class="input-container">
                                    <div class="input-group mg-b">
                                        <input id="address" placeholder="Adresa" name="address" type="text" :value="project.address">
                                        <div class="input-icon">
                                            <i class="fad fa-phone-rotary"></i>
                                        </div>
                                        <label class="custom-label" for="address"> Adresa </label>
                                    </div>
                                    <p class="custom-input-error" id="address_error"></p>
                                </div>
                            </div>
                            <GMDefineArea ref="gmarea" draggable="false"></GMDefineArea>
                            <p class="custom-input-error" id="address_area_error"></p>
                            <input class="positive-btn btn-sm text-dark" type="button" id="resetPolygon" value="Reseteaza" />      
                            <input class="positive-btn btn-sm text-dark" type="button" id="enablePolygon" value="Calculeaza din nou perimetrul" />
                            <label class="toggleCheckBoxStuff" >
                            <input type="checkbox"
                                id="toggleCheckBox"
                                value="toggleCheck" 
                                @click="toggleContent" />
                                Vezi perimetrul actual!
                            </label>
                            <div class="toBeToggled" style="display:none;" id="toBeToggled" >
                            <GMDefineArea ref="gmarea2"
                                  :default-area="project.address_area"
                                  :default-lat="project.marker_lat"
                                  :default-lng="project.marker_lng"
                                  :def-lat-marker="project.marker_lng"
                                  :def-lng-marker="project.marker_lng"
                                  :disable-draggable="true"></GMDefineArea>
                            <p class="custom-input-error" id="address_area_error"></p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row project-step-row">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                        <div class="description-wrapper">
                            <div class="secondary-heading">
                                <div class="secondary-heading-icon">
                                    <i class="fad fa-align-left"></i>
                                </div>
                                <span> * Descriere </span>
                            </div>
                            <div class="editor-wrapper">
                                <vue-editor
                                    v-model="description"
                                    :editorOptions="{
                                        modules: {
                                            toolbar: [
                                                [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                                                ['bold', 'italic', 'underline', 'strike'],
                                                [{ 'align': ''}, {'align': 'center'}, { 'align': 'right'}, {'align': 'justify'}],
                                                [{ 'list': 'bullet' }, { 'list': 'ordered'}, { 'indent': '-1'}, { 'indent': '+1' }],
                                                ['clean'],
                                                [{ 'color': [] }, { 'background': [] }],
                                                ['link', 'image', 'video', 'emoji'],
                                            ],
                                            'emoji-toolbar': true,
                                            // 'emoji-textarea': true,
                                            'emoji-shortname': true,
                                        }
                                    }"/>
                                <p class="custom-input-error" id="description_error"></p>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-4">
                        <div class="description-wrapper">
                            <div class="secondary-heading">
                                <div class="secondary-heading-icon">
                                    <i class="fad fa-align-left"></i>
                                </div>
                                <span> * Descriere scurta (max. 200 caractere) </span>
                            </div>
                            <div class="editor-wrapper">
                                <vue-editor
                                    v-model="short_description"
                                    :editorOptions="{
                                        modules: {
                                            toolbar: [
                                                [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                                                ['bold', 'italic', 'underline', 'strike'],
                                                [{ 'align': ''}, {'align': 'center'}, { 'align': 'right'}, {'align': 'justify'}],
                                                [{ 'list': 'bullet' }, { 'list': 'ordered'}, { 'indent': '-1'}, { 'indent': '+1' }],
                                                ['clean'],
                                                [{ 'color': [] }, { 'background': [] }],
                                                ['link', 'image', 'video', 'emoji'],
                                            ],
                                            'emoji-toolbar': true,
                                            // 'emoji-textarea': true,
                                            'emoji-shortname': true,
                                        }
                                    }"/>
                                <p class="custom-input-error" id="short_description_error"></p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row project-step-row">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                        <div class="payment-methods-wrapper">
                            <div class="secondary-heading">
                                <div class="secondary-heading-icon">
                                    <i class="fad fa-euro-sign"></i>
                                </div>
                                <span> Modalitate Plata </span>
                            </div>
                            <div class="payment-cards row">
                                <div class="col-xl-12 col-lg-12 col-md-12 col-12 ml-auto">
                                    <div class="general-check step-check d-flex justify-content-start" style="padding-left: 75px; margin-bottom: 10px;">
                                        <input type="checkbox" name="rates_to_developer" value="1" id="rates_to_developer" class="custom-checkbox" :checked="project.rates_to_developer">
                                        <label for="rates_to_developer" class="custom-checkbox-label">
                                            <span></span>
                                            <p>
                                                Sunt acceptate rate direct la dezvoltator
                                            </p>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mx-auto">
                                    <div class="editor-wrapper">
                                        <vue-editor
                                            v-model="payment_method"
                                            :editorOptions="{
                                                modules: {
                                                    toolbar: [
                                                        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                                                        ['bold', 'italic', 'underline', 'strike'],
                                                        [{ 'align': ''}, {'align': 'center'}, { 'align': 'right'}, {'align': 'justify'}],
                                                        [{ 'list': 'bullet' }, { 'list': 'ordered'}, { 'indent': '-1'}, { 'indent': '+1' }],
                                                        ['clean'],
                                                        [{ 'color': [] }, { 'background': [] }],
                                                        ['link', 'image', 'video', 'emoji'],
                                                    ],
                                                    'emoji-toolbar': true,
                                                    // 'emoji-textarea': true,
                                                    'emoji-shortname': true,
                                                }
                                            }"/>
                                        <p class="custom-input-error" id="payment_method_error"></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row project-step-row">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                        <div class="secondary-heading">
                            <div class="secondary-heading-icon">
                                <i class="fad fa-images"></i>
                            </div>
                            <span> Imagini Proiect </span>
                        </div>
                        <div class="project-images-wrapper">
                            <p class="custom-input-error" :id="`ungroupedImages-${index}_error`"
                               v-for="(img, index) in ungroupedImages" :key="`ung-${index}`"></p>
                            <div class="row">
                                <div class="col-12">
                                    <div class="images-group-uploader">
                                        <input type="file" id="groupImages" multiple
                                               @change="onMultipleFileChange">
                                        <label for="groupImages" class="general-btn positive-btn">
                                            <span> Incarca imagini </span>
                                            <i class="fad fa-upload"></i>
                                        </label>
                                    </div>
                                    <draggable :forceFallback="true" v-if="ungroupedImages" class="images-group card-columns"
                                               :list="ungroupedImages" group="picsGroup">
                                        <div v-for="(image, index, key) in ungroupedImages" :key="key"
                                             class="group-uploaded-img card">
                                            <img :src="image.base64" @click="triggerImg"/>
                                            <div class="clear-post-img" @click="removeUngroupImage(index)">
                                                <i class="fad fa-trash-alt"></i>
                                            </div>
                                        </div>
                                    </draggable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row project-step-row">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="secondary-heading">
                            <div class="secondary-heading-icon">
                                <i class="fad fa-video"></i>
                            </div>
                            <span> Link Video Live </span>
                        </div>
                        <div class="video-links-wrapper">
                            <div class="row">
                                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                                    <div class="input-container">
                                        <div class="input-group mg-b">
                                            <input placeholder="Link Video Live" v-model="liveVideoURL" name="video_live" type="text">
                                            <div class="input-icon">
                                                <i class="fad fa-signal-stream"></i>
                                            </div>
                                            <label class="custom-label sr-only"> Link Video Live </label>
                                        </div>
                                        <span class="floating-remove-el" @click="liveVideoURL=''">
                                            <i class="fad fa-times-circle"></i>
                                        </span>
                                    </div>
                                    <linkPrevue :url="liveVideoURL">
                                        <template slot-scope="props">
                                            <div class="prevue-card">
                                                <a v-bind:href="props.url" target="_blank"
                                                   class="general-btn positive-btn prevue-viewmore-btn">
                                                    <i class="fad fa-eye"></i>
                                                    <span> Vezi link video </span>
                                                </a>
                                            </div>
                                        </template>
                                    </linkPrevue>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row project-step-row">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="secondary-heading">
                            <div class="secondary-heading-icon">
                                <i class="fad fa-video"></i>
                            </div>
                            <span> Linkuri Video Proiect (doar linkuri Youtube) </span>
                        </div>
                        <div class="video-links-wrapper">
                            <div class="row">
                                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 mb-4" v-for="(videoRow, index) in videoRows" :key="index">
                                    <div class="input-container">
                                        <div class="input-group mg-b">
                                            <input v-model="videoRow.url" placeholder="Link Video" type="text" name="video[]">
                                            <div class="input-icon">
                                                <i class="fad fa-video"></i>
                                            </div>
                                            <label class="custom-label sr-only"> Link Video </label>
                                        </div>
                                        <span class="floating-remove-el" @click="removeVideoElement(index)">
                                            <i class="fad fa-times-circle"></i>
                                        </span>
                                        <p class="custom-input-error" :id="`video-${index}_error`"></p>
                                    </div>
                                    <linkPrevue :url="videoRow.url">
                                        <template slot-scope="props">
                                            <div class="prevue-card">
                                                <a v-bind:href="props.url" target="_blank"
                                                   class="general-btn positive-btn prevue-viewmore-btn">
                                                    <span> Vezi link </span>
                                                    <i class="fad fa-eye"></i>
                                                </a>
                                            </div>
                                        </template>
                                    </linkPrevue>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="center-content mt-3 save-btn">
                            <p class="general-btn positive-btn" @click="addVideoRow()">
                                <i class="fad fa-video-plus"></i>
                                <span> Adauga link </span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="row project-heading-row" style="position: relative;">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                        <div class="center-content mt-3 save-btn">
                            <button type="submit" class="general-btn positive-btn">
                                <i class="fad fa-save"></i>
                                <span> Salveaza </span>
                            </button>
                        </div>
                    </div>
                    <div class="section-loading-screen" v-if="showLoading">
                        <div class="section-loading-bubbles">
                            <span class="d1"></span>
                            <span class="d2"></span>
                            <span class="d3"></span>
                            <span class="d4"></span>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div id="fullscreen-preview" class="fullscreen-img" :class="{'fullscreen-img-active' : fullScreen}">
            <!-- :style="{backgroundImage: `url(${src})`}" -->
            <div class="fullscreen-container" v-if="fullScreenScr">
                <img :src="fullScreenScr" alt="">
            </div>
            <div class="close-element" @click="fullScreen = !fullScreen">
                <i class="fad fa-times-circle"></i>
            </div>
        </div>
    </section>
</template>

<script>
  import draggable from 'vuedraggable'
  import linkPrevue from 'link-prevue'
  import GMDefineArea from "../partials/GMDefineArea";
  import $ from 'jquery'
  import { VueEditor, Quill } from "vue2-editor";
  import Emoji from "quill-emoji/dist/quill-emoji";

  Quill.register("modules/emoji", Emoji);

  export default {
    name: "EditProject",
    props: ['counties','project', 'images', 'promotionLevels'],
    components: {
      GMDefineArea,
      draggable,
      linkPrevue,
      VueEditor
    },
    data() {
      return {
        editor: null,
        showLoading: false,
        description: this.project.description,
        short_description: this.project.short_description,
        payment_method: this.project.payment_method,
        selectedCity: null,
        selectedZone: null,
        selectedSubzone: null,
        selectedPromotionLevel: null,
        liveVideoURL: '',
        videoRows: [],
        ungroupedImages: [],
        image: '',
        logoUrl: '',
        contactRows: [
          {
            name: '',
            phone: '',
            email: ''
          }
        ],
        files: [],
        cities: [],
        zones: [],
        subzones: [],
        fullScreenScr: '',
        toggleCheck: false,
        fullScreen: false,
        deleteImages: []
      }
    },
    mounted() {
      let vm = this;
      $('#form-edit-project').submit(function (e) {
        e.preventDefault();
        vm.save();
      })
      $('[data-toggle="tooltip"]').tooltip()
      this.ungroupedImages = (this.images[0]) ? this.images[0] : []
      this.changeCounty(true)
      let contacts = this.project.contacts;
      if (contacts.length > 0) {
        this.contactRows = [];
        for (let index = 0; index < contacts.length; index++) {
          this.contactRows.push({
            name: contacts[index].name,
            phone: contacts[index].phone,
            email: contacts[index].email
          })
        }
      }
      if (this.project.media.length > 0) {
        if(this.project.media.find(image => image.collection_name === 'logo')) {
          let logo = this.project.media.find(image => image.collection_name === 'logo')
          this.logoUrl = `${process.env.MIX_STORAGE_URL}/${logo.id}/${logo.file_name}`
        }
      }

      let videos = this.project.videos.filter(video => video.type === 'video');
      if(videos && videos.length > 0) {
        videos.forEach(function (video) {
          vm.videoRows.push({url: video.link});
        });
      } else {
        vm.videoRows.push({url: ''});
      }


      let videoLive = this.project.videos.find(video => video.type === 'live');
      if(videoLive) {
        this.liveVideoURL = videoLive.link;
      }

      this.$refs.gmarea2.addressArea = this.project.address_area
      if(!this.project.address_area || this.project.address_area.length <= 0) {
        this.$refs.gmarea2.disableArea = false;
      }

      if(parseFloat(this.project.marker_lat) > 0  && parseFloat(this.project.marker_lng) > 0){
        this.$refs.gmarea.lngMarker = parseFloat(this.project.marker_lng)
        // this.$refs.gmarea.defLngMarker = parseFloat(this.project.marker_lng)

        this.$refs.gmarea.latMarker = parseFloat(this.project.marker_lat)
        // this.$refs.gmarea.defLatMarker = parseFloat(this.project.marker_lat)
      }
    },
    methods: {
       addVideoRow: function() {
         this.videoRows.push({
             url: ''
         });
      },
      removeVideoElement: function(index) {
        if ((index < 1) && (this.videoRows.length < 2)) {
            this.videoRows[0].url = '';
            return;
        }
        this.videoRows.splice(index, 1);
      },
      triggerImg: function (img) {
        this.fullScreenScr = img.srcElement.src;
        this.fullScreen = !this.fullScreen
      },
      onFileChange(e) {
        const file = e.target.files[0];
        this.logoUrl = URL.createObjectURL(file);
        this.image = file;
      },
      deleteLogo() {
        this.logoUrl = null;
        this.image = '';
        if (this.project.media.length > 0) {
          if(this.project.media.find(image => image.collection_name === 'logo')) {
            let logo = this.project.media.find(image => image.collection_name === 'logo')
            this.deleteImages.push(logo.id)
          }
        }
      },

      toggleContent() {
        this.toggleCheck = !this.toggleCheck;
            if (this.toggleCheck == true) {
                $("#toBeToggled").slideDown();
            } else {
                $("#toBeToggled").slideUp();
            }
        },

      onMultipleFileChange(e) {
        let files = e.target.files || e.dataTransfer.files;
        if (!files.length)
          return;
        this.createImage(files);
      },
      createImage(files) {
        let vm = this;
        for (let index = 0; index < files.length; index++) {
          let fileType = files[index].type;
          if(fileType === "image/jpeg" || fileType === "image/png") {
            let reader = new FileReader();
            reader.onload = function (event) {
              const groupImageUrl = {base64: event.target.result};
              vm.ungroupedImages.push(groupImageUrl);
            }
            reader.readAsDataURL(files[index]);
          } else {
            window.Swal.fire({
              html: 'Sunt permise doar imagini de tip jpg sau png',
              icon: 'warning'
            })
          }
        }
      },
      removeUngroupImage(index) {
        if (this.ungroupedImages[index].id) {
          this.deleteImages.push(this.ungroupedImages[index].id)
        }
        this.ungroupedImages.splice(index, 1)
      },

      addContactRow: function () {
        this.contactRows.push({
          name: "",
          phone: "",
          email: ""
        });
      },
      removeContactElement: function (index) {
        this.contactRows.splice(index, 1);
      },
      changeCounty(def = false) {
        this.cities = [];
        this.zones = [];
        this.subzones = [];
        let countySel = $('#pas1_county').val();
        if (countySel) {
          let county = this.counties.find(element => element.id === parseInt(countySel));
          if (county) {
            this.cities = county.cities
            if (this.project.city && def) {
              this.selectedCity = this.project.city.id
              this.changeCity(true)
            }
            window.triggerLabel();
          }
        }
      },
      changeCity(def = false) {
        let vm = this;
        this.zones = [];
        this.subzones = [];
        let city = this.cities.find(city => parseInt(city.id) === parseInt(this.selectedCity))
        if(city.latitude && city.longitude) {
          this.$refs.gmarea.lat = parseFloat(city.latitude);
          this.$refs.gmarea.lng = parseFloat(city.longitude);
          this.$refs.gmarea.latMarker = parseFloat(city.latitude);
          this.$refs.gmarea.lngMarker = parseFloat(city.longitude);

          this.$refs.gmarea.addressArea = [];
          if(this.$refs.gmarea.drawingManager) {
            this.$refs.gmarea.disableArea = false
            this.$refs.gmarea.drawingManager.setOptions({
              drawingControl: true,
              drawingMode: window.google.maps.drawing.OverlayType.POLYGON
            });
          }
        }

        if (this.selectedCity) {
          window.axios.get(`/get-zones-by-city/${this.selectedCity}`)
            .then(function (response) {
              vm.zones = response.data.data;
              if (vm.project.zone && def) {
                vm.selectedZone = vm.project.zone.id
                vm.changeZone(true)
              }
              window.triggerLabel()
            })
            .catch(function (err) {
              window.showError(err)
            });
        }
      },
      changeZone(def) {
        let vm = this;
        this.subzones = [];
        if (this.selectedZone) {
          window.axios.get(`/get-subzones-by-zone/${this.selectedZone}`)
            .then(function (response) {
              vm.subzones = response.data.data;
              if (vm.project.subzone && def) {
                vm.selectedSubzone = vm.project.subzone.id
                vm.changeSubzone()
              }
              window.triggerLabel()
            })
            .catch(function (err) {
              window.showError(err)
            });
        }
      },
      changeSubzone() {
        window.triggerLabel()
      },
      save() {
        let addressArea = this.$refs.gmarea.addressArea;
        if(!addressArea.length) {
          // the user did not edit the map area
          addressArea = this.$refs.gmarea2.addressArea;
        }

        window.resetErrors()
        let vm = this;
        vm.showLoading = true;
        let myForm = document.getElementById('form-edit-project');
        let formData = new FormData(myForm);

        // send only new images
        let sendImages = [];
        this.ungroupedImages.forEach(function(image) {
          let imageClone = JSON.parse(JSON.stringify(image));
          if (imageClone.id && imageClone.id > 0) {
            delete imageClone.base64;
          }
          sendImages.push(imageClone);
        })
        formData.append('ungroupedImages', JSON.stringify(sendImages));
        formData.append('deleteImages', JSON.stringify(this.deleteImages));
        formData.append('addressArea', JSON.stringify(addressArea));
        formData.append('marker_lat', JSON.stringify(this.$refs.gmarea.latMarker));
        formData.append('marker_lng', JSON.stringify(this.$refs.gmarea.lngMarker));
        if(this.description != null) {
          formData.append('description', this.description);
        }
        if(this.short_description != null) {
          formData.append('short_description', this.short_description);
        }
        if(this.payment_method != null) {
          formData.append('payment_method', this.payment_method);
        }
        window.axios.post(`/developer/project/${this.project.id}/edit`, formData)
          .then(function () {
            vm.showLoading = false;
            window.Swal.fire({
              html: 'Proiectul a fost modificat cu succes',
              icon: 'success',
              timer: 2000,
              showCancelButton: false,
              showConfirmButton: false
            }).then(() => {
              //window.location.href = `/developer/project/${vm.project.id}`
            })
          })
          .catch(function (err) {
            vm.showLoading = false;
            vm.buttonDisable = false;
            window.showError(err)
          });
      }
    }
  }
</script>
<style>
@import "~quill-emoji/dist/quill-emoji.css";
</style>